import React, { useContext } from 'react'
import { Button, Icon, Menu, Tab } from 'semantic-ui-react'
import { primaryColor } from '../../../../constants'
import IntelMsg from '../../../ItelMsg'
import { CustomerViewContext } from '../customer-info-view/customerView'
import InactivitySettings from './InactivitySettings'
import CommunicationSettings from './communicationSettings'
import CustomerConfigurations from './customerConfigurations'
import CustomerDynamicAlertSettings from './customerDynamicAlertSettings'
import CustomerSuddenDropSettings from './CustomerSuddenDropSettings'
import styles from './customerSettings.module.css'
import StaticAlertSettings from './staticAlertSettings'

const panes = [
  {
    menuItem: (
      <Menu.Item key={1} className={styles.tabs}>
        Configuration Settings
      </Menu.Item>
    ),
    render: () => <CustomerConfigurations />,
  },
  {
    menuItem: (
      <Menu.Item key={2} className={styles.tabs}>
        Communication Settings
      </Menu.Item>
    ),
    render: () => <CommunicationSettings />,
  },
  {
    menuItem: (
      <Menu.Item key={3} className={styles.tabs}>
        Static Alert Settings
      </Menu.Item>
    ),
    render: () => <StaticAlertSettings />,
  },
  {
    menuItem: (
      <Menu.Item key={4} className={styles.tabs}>
        Dynamic Alert Settings
      </Menu.Item>
    ),
    render: () => <CustomerDynamicAlertSettings />,
  },
  {
    menuItem: (
      <Menu.Item key={5} className={styles.tabs}>
        Inactivity Settings
      </Menu.Item>
    ),
    render: () => <InactivitySettings />,
  },
  {
    menuItem: (
      <Menu.Item key={6} className={styles.tabs}>
        Customer sudden drop settings
      </Menu.Item>
    ),
    render: () => <CustomerSuddenDropSettings />,
  },
]

const CustomerSettings = () => {
  const { setViewNetworkSettings } = useContext(CustomerViewContext)
  return (
    <>
      <div className={styles.container}>
        <IntelMsg id="customerSettings" />
      </div>
      <br />
      <Tab
        menu={{
          attached: false,
          inverted: false,
          pointing: true,
        }}
        panes={panes}
      />

      <div className={styles.actions}>
        <Button
          form="customerSettings"
          type="submit"
          style={{ backgroundColor: primaryColor, color: 'white' }}
          onClick={() => setViewNetworkSettings(false)}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>
    </>
  )
}

export default CustomerSettings
